import { useCallback, useEffect } from 'react';
import { PlaylistEnum } from '../enum/PlaylistEnum';
import { ListReguaLogo } from '../helpers/ListReguaLogo';
import useTypePlayList from './useTypePlayList';

const useFetchReguaLogo = () => {
    const { handleTypePlayList, id } = useTypePlayList();

    const getReguaLogo = useCallback(() => {
        const params = handleTypePlayList();

        switch (params) {
            case PlaylistEnum.SEMINARIO:
                return ListReguaLogo.find(logo => logo.type === PlaylistEnum.SEMINARIO)?.regua || null;
            case PlaylistEnum.PROMOVER_ALFABETIZACAO:
                return ListReguaLogo.find(logo => logo.type === PlaylistEnum.PROMOVER_ALFABETIZACAO)?.regua || null;
            default:
                return null;
        }
    }, [id]);

    return { getReguaLogo };
};

export default useFetchReguaLogo;
